export const GET_CUSTOM_PAYMENT_TYPES_REQUESTED =
  'GET_CUSTOM_PAYMENT_TYPES_REQUESTED'
export const GET_CUSTOM_PAYMENT_TYPES_SUCCEEDED =
  'GET_CUSTOM_PAYMENT_TYPES_SUCCEEDED'
export const GET_CUSTOM_PAYMENT_TYPES_FAILED =
  'GET_CUSTOM_PAYMENT_TYPES_FAILED'

export const GET_FILTERED_AND_PAGINATED_CUSTOM_PAYMENT_TYPES_REQUESTED =
  'GET_FILTERED_AND_PAGINATED_CUSTOM_PAYMENT_TYPES_REQUESTED'
export const GET_FILTERED_AND_PAGINATED_CUSTOM_PAYMENT_TYPES_SUCCEEDED =
  'GET_FILTERED_AND_PAGINATED_CUSTOM_PAYMENT_TYPES_SUCCEEDED'
export const GET_FILTERED_AND_PAGINATED_CUSTOM_PAYMENT_TYPES_FAILED =
  'GET_FILTERED_AND_PAGINATED_CUSTOM_PAYMENT_TYPES_FAILED'

export const UPDATE_CUSTOM_PAYMENT_TYPES_REQUESTED =
  'UPDATE_CUSTOM_PAYMENT_TYPES_REQUESTED'
export const UPDATE_CUSTOM_PAYMENT_TYPES_SUCCEEDED =
  'UPDATE_CUSTOM_PAYMENT_TYPES_SUCCEEDED'
export const UPDATE_CUSTOM_PAYMENT_TYPES_FAILED =
  'UPDATE_CUSTOM_PAYMENT_TYPES_FAILED'

export const CREATE_CUSTOM_PAYMENT_TYPES_REQUESTED =
  'CREATE_CUSTOM_PAYMENT_TYPES_REQUESTED'
export const CREATE_CUSTOM_PAYMENT_TYPES_SUCCEEDED =
  'CREATE_CUSTOM_PAYMENT_TYPES_SUCCEEDED'
export const CREATE_CUSTOM_PAYMENT_TYPES_FAILED =
  'CREATE_CUSTOM_PAYMENT_TYPES_FAILED'

export const DELETE_CUSTOM_PAYMENT_TYPES_REQUESTED =
  'DELETE_CUSTOM_PAYMENT_TYPES_REQUESTED'
export const DELETE_CUSTOM_PAYMENT_TYPES_SUCCEEDED =
  'DELETE_CUSTOM_PAYMENT_TYPES_SUCCEEDED'
export const DELETE_CUSTOM_PAYMENT_TYPES_FAILED =
  'DELETE_CUSTOM_PAYMENT_TYPES_FAILED'
